// TODO: strings in this file for now as I don't know if this modal should be in 'src/modals'
export const QUALIFY_MODAL_STRINGS = {
  'modal.title': 'Enter Your Details And\u00a0Receive',
  'form.firstName': 'First Name',
  'form.lastName': 'Last Name',
  'form.email': 'Email address',
  'form.phone': 'Phone',
  'form.submit': 'Get Started',
  divider: 'Or',
  'sign_up.already_a_member': 'Already a member?',
  'sign_up.sign_in': 'SIGN IN',
  'success.title': `We'll get back to you\u00a0soon!`,
  'success.cta': `Close`,
  'phone.text': 'Questions? ',

  'generic.something_went_wrong': 'Something went\u00a0wrong!',
  'login.fb_login_email_mismatch_line_1':
    'Looks like your Facebook account\u00a0doesn’t\u00a0match.',
  'login.fb_login_email_mismatch_line_2':
    'Please create an account with the email\u00a0below.',
  'login.google_third_party_error':
    'Please allow 3rd-party cookies to login with\u00a0Google.',
};
